//Maritime Signal Flags Translator by 101Computing.net
//www.101Computing.net/maritime-signal-flags-translator/

function convert() {
  console.log("Convert function execution")
   var input = document.getElementById("message").value.toUpperCase();
   var output = document.getElementById("output");
   //Reset Output box
   output.innerHTML="";
  
   //Loop through each character
   for (var i = 0; i < input.length; i++) {
      var character = input.charAt(i);
      if ("ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789".indexOf(character)>=0) {
         var flag = document.createElement("DIV");  
         flag.className="flag flag" + character;
         output.appendChild(flag); 
        
        console.log(flag)
      }
   }
}

convert();